export * from "./TooltipsContext";
export * from "./TooltipsProvider";
export * from "./useTooltips";

// Registers the sbb-tooltip custom element, which activates its own document-wide
// MutationObserver that turns any [sbb-tooltip] attribute into a tooltip.
import "@sbb-esta/lyne-elements/tooltip.js";
